import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import { LogOutResponseBody } from "../../../reduxStore/logOut/Model";
import { logOut } from "../../../reduxStore/logOut/logOutSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../reduxStore/store";
import { useAppSelector } from "../../../reduxStore/hooks";
import { useNavigate } from "react-router-dom";

export default function AccountMenu() {
  const theme = useTheme();
  const logOutRes = useAppSelector((state) => state.logOut);
  const dispatch = useDispatch<AppDispatch>();
   let navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const token = localStorage.getItem("access");
  const refresh = localStorage.getItem("refresh");
  const logoutHandle = () => {
    const logOutBody = {
      token: token,
      refresh_token: refresh,
    } as LogOutResponseBody;
    dispatch(logOut(logOutBody));
  };

  // Handle logout response changes
  React.useEffect(() => {
    if (logOutRes.successMsg) {
      // Logout successful - redirect to login         
      localStorage.clear();
      navigate("/login");
    }
  }, [logOutRes.successMsg, navigate]);
  
  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              sx={{ width: 36, height: 36, color: theme.palette.text.primary }}
              sizes="small"
              alt="Souman Paul"
              src="/static/images/avatar/7.jpg"
              variant="rounded"
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleClose}>
          Logged in as &nbsp;
          <strong style={{ textTransform: "capitalize" }}>
            {/* {userDetails?.response?.user?.username} */}Souman Paul
          </strong>
        </MenuItem>
        <Divider />
        <MenuItem onClick={logoutHandle}>
          Sign Out &nbsp;&nbsp;
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
